import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  IBecomeMemberFromData,
  IFormRequirement,
  IMemberShipType,
} from "../../exports/interfaces";
import { marked } from "marked";
// import qr from "../../assets/images/frcsit-qr-code2.png";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Fade } from "react-awesome-reveal";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";
import { useLoader } from "../../context/LoaderContext";
import axios from "axios";
import { dynamicFailed, dynamicSuccess } from "../../hooks/useToast";
import { headers } from "../../exports/exports";
import { toWords } from "number-to-words";
import useMobile from "../../hooks/useMobile";
import { useLocation, useNavigate } from "react-router-dom";
import { countryDetails } from "../../exports/countrydetails";
import FormRequirementsPopup from "../FormRequirementsPopup";
import DropDownInput from "../DropDownInput";
import { getFormattedDate } from "../../exports/functions";
import useTab from "../../hooks/useTab";
import { sendErrorLog } from "../ErrorLog";
import {
  checkEmailExists,
  checkPhoneExists,
  deleteFromUser,
} from "../../api/UserApi";

const BecomeMemberForm = (props: {
  becomeMemberData: IBecomeMemberFromData[];
  token: string;
  membershipType: IMemberShipType[];
  formRequirement: IFormRequirement[];
}) => {
  const { loading, setLoading, setShowWarning } = useLoader();
  const mobile = useMobile();
  const tab = useTab();
  const formRef = useRef<HTMLFormElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  // const token = localStorage.getItem("frcsit:access-token");
  // const sisheaders = { Authorization: `Bearer ${token}` };
  const sisheaders = { Authorization: `Bearer ${props.token}` };
  const { companyDetailsData } = useCompanyDetailsContext();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [reenterPassword, setReenterPassword] = useState<string>("");
  const [firstname, setFirstname] = useState<string>("");
  const [middlename, setMiddlename] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [age, setAge] = useState<number | null>(null);
  const [sex, setSex] = useState<string>("");
  const [ent, setEnt] = useState<string | null>(null);
  const [designation, setDesignation] = useState<string>("");
  const [qualifications, setQualifications] = useState<string>("");
  const [professionalAffiliations, setProfessionalAffiliations] =
    useState<string>("");
  const [mobilenumber, setMobileNumber] = useState<string>("");
  const [whatsappnumber, setWhatsappNumber] = useState<string>("");
  const [permanentAddress, setPermanentAddress] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [stateProvince, setStateProvince] = useState<string>("");
  const [postalZipCode, setPostalZipCode] = useState<number | null>(null);
  const [country, setCountry] = useState<string>("");
  const [workAddress, setWorkAddress] = useState<string>("");
  const [workCity, setWorkCity] = useState<string>("");
  const [workStateProvince, setWorkStateProvince] = useState<string>("");
  const [workPostalZipCode, setWorkPostalZipCode] = useState<number | null>(
    null,
  );
  const [workCountry, setWorkCountry] = useState<string>("");
  const [proposer1Name, setProposer1Name] = useState<string>("");
  const [proposer1MembershipNumber, setProposer1MembershipNumber] = useState<
    number | null
  >(null);
  const [proposer2Name, setProposer2Name] = useState<string>("");
  const [proposer2MembershipNumber, setProposer2MembershipNumber] = useState<
    number | null
  >(null);
  const [membershipType, setMembershipType] = useState<string>("");
  const [membershipExpiry, setMembershipExpiry] = useState<number>(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [previews, setPreviews] = useState<{ [key: number]: string }>({});
  const [openAccordion, setOpenAccordion] = useState<
    "permanent" | "work" | null
  >("permanent");
  const [showRequirements, setShowRequirements] = useState(false);

  const toggleAccordion = (section: "permanent" | "work") => {
    setOpenAccordion((prev) => (prev === section ? null : section));
  };
  const [selectedFiles, setSelectedFiles] = useState<{ [key: number]: File }>(
    {},
  );

  const uploadFields = [
    {
      id: 1,
      label: "Photograph*",
      types: "png, jpg, jpeg",
      name: "Photograph",
    },
    {
      id: 2,
      label: "Bachelor Degree*",
      types: "png, jpg, jpeg, pdf",
      name: "Bachelor_Degree",
    },
    {
      id: 3,
      label: "Master Degree*",
      types: "png, jpg, jpeg, pdf",
      name: "Master_Degree",
    },
    {
      id: 4,
      label: "MCI/State Council Registration*",
      types: "png, jpg, jpeg, pdf",
      name: "MCI",
    },
    {
      id: 5,
      label: "Photo ID (Aadhar/Driving License/Voter ID/Passport)*",
      types: "png, jpg, jpeg",
      name: "Photo_ID",
    },
    {
      id: 6,
      label: "Curriculum Vitae*",
      types: "pdf",
      name: "Curriculum_Vitae",
    },
  ];

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number,
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setSelectedFiles((prev) => ({
        ...prev,
        [id]: file,
      }));

      const url = URL.createObjectURL(file);
      setPreviews((prev) => ({
        ...prev,
        [id]: url,
      }));
    }
  };
  const memberData = location.state?.memberData;

  // const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (file) {
  //     const url = URL.createObjectURL(file);
  //     setSelectedFile(file);
  //     setPreview(url);
  //     setIsPdf(file.type === "application/pdf");
  //   }
  // };

  const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"];
  const memberDetailsRef = useRef<HTMLDivElement>(null);
  const markedDescription = marked(
    props?.becomeMemberData[0]?.description || "",
  ) as string;
  const [step, setStep] = useState<number>(0);
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);
  const [selectedMembership, setSelectedMembership] = useState<number | null>();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleRePasswordVisibility = () => {
    setShowRePassword(!showRePassword);
  };
  const memberships = props.membershipType;
  const filteredMemberships = useMemo(() => {
    return memberships.filter(
      (membership) =>
        !(
          ent === "No" &&
          membership.title.toLowerCase().replace(/\s|-/g, "") ===
            "onetimemembership"
        ),
    );
  }, [ent, memberships]);

  useEffect(() => {
    if (filteredMemberships.length > 0) {
      setMembershipExpiry(filteredMemberships[0]?.expires_in_yrs);
      setMembershipType(
        `${filteredMemberships[0]?.title} ${
          filteredMemberships[0]?.expires_in_yrs === 1
            ? "(ANNUALLY)"
            : filteredMemberships[0]?.expires_in_yrs === 0
              ? ""
              : `(${toWords(
                  filteredMemberships[0]?.expires_in_yrs,
                ).toUpperCase()} YEARS)`
        }`,
      );
    }
  }, [filteredMemberships]);

  useEffect(() => {
    setSelectedMembership(filteredMemberships[0]?.id);
  }, [filteredMemberships]);

  const handleNext = async () => {
    if (step === 1) {
      setOpenAccordion("permanent");
    }
    const isValid = await validateStep();

    if (isValid) {
      setStep((prev) => prev + 1);
      markStepCompleted(step);
    }
    memberDetailsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSelectMembership = (membershipId: number) => {
    setSelectedMembership(membershipId);
  };

  const handlePrev = () => {
    setStep((prevStep) => prevStep - 1);
    memberDetailsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
  const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email);
  const validateStep = async (targetStep?: number) => {
    let newErrors: { [key: string]: string } = {};
    let passwordErrorList: string[] = [];
    if (targetStep ? targetStep === 0 : step === 0) {
      const emailExists = await checkEmailExists(email);
      if (!email) newErrors.email = "Email is required";
      else if (!isValidEmail(email)) newErrors.email = "Invalid email format";
      else if (emailExists) newErrors.email = "Email already exists";
      if (!password) passwordErrorList.push("required");
      if (password.length < 8) passwordErrorList.push("8char");
      if (!/[A-Z]/.test(password)) passwordErrorList.push("uppercase");
      if (!/\d/.test(password)) passwordErrorList.push("number");
      if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
        passwordErrorList.push("symbol");
      if (!reenterPassword)
        newErrors.reenterPassword = "Please re-enter your password";
      else if (password !== reenterPassword)
        newErrors.reenterPassword = "Password do not match";
      if (!firstname) newErrors.firstname = "First Name is required";
      if (!lastname) newErrors.lastname = "Last Name is required";

      if (!age) newErrors.age = "Age is required";
      if (!sex) newErrors.sex = "Please select a gender";

      if (!ent) newErrors.ent = "Please select ENT";
      if (!designation) newErrors.designation = "Designation is required";
      if (!qualifications)
        newErrors.qualifications = "Qualifications are required";
      if (!professionalAffiliations)
        newErrors.professionalAffiliations =
          "Professional Affiliations are required";
    }

    if (targetStep ? targetStep === 1 : step === 1) {
      const phoneExists = await checkPhoneExists(mobilenumber);
      if (!mobilenumber) {
        newErrors.mobilenumber = "Mobile Number is required";
      } else if (phoneExists) {
        newErrors.mobilenumber = "Mobile Number already exists";
      }
      // else if (!/^\d{10}$/.test(mobilenumber)) {
      //   newErrors.mobilenumber = "Mobile Number must be exactly 10 digits";
      // }

      if (!permanentAddress)
        newErrors.permanentAddress = "Permanent Address is required";

      if (!city) newErrors.city = "City is required";
      if (!stateProvince)
        newErrors.stateProvince = "State/Province is required";

      // if (!postalZipCode)
      //   newErrors.postalZipCode = "Postal/Zip Code is required";
      // else if (postalZipCode.toString().length < 4)
      //   newErrors.postalZipCode =
      //     "Postal/Zip Code must be at least 4 digits long";

      if (postalZipCode && postalZipCode.toString().length < 4)
        newErrors.postalZipCode =
          "Postal/Zip Code must be at least 4 digits long";

      if (!country) newErrors.country = "Country is required";
    }
    if (targetStep ? targetStep === 2 : step === 2) {
      uploadFields.forEach((field) => {
        if (!selectedFiles[field.id]) {
          newErrors[`file_${field.id}`] = `${field.label} is required`;
        }
      });
    }
    if (step === 3) {
      const isAnyProposerFilled =
        proposer1Name ||
        proposer1MembershipNumber ||
        proposer2Name ||
        proposer2MembershipNumber;

      if (isAnyProposerFilled && !isChecked) {
        newErrors.declaration = "You must declare the given information.";
      }
    }
    setErrors(newErrors);
    setPasswordErrors(passwordErrorList);

    return (
      Object.keys(newErrors).length === 0 && passwordErrorList.length === 0
    );
  };

  // const handleRenew = async () => {
  //   if (!validatePaymentReciept()) {
  //     return;
  //   }

  //   let uploadedId = null;
  //   setLoading(true);
  //   try {
  //     if (selectedFile) {
  //       const formData = new FormData();
  //       formData.append("files", selectedFile);

  //       const uploadRes = await axios.post(
  //         `${process.env.REACT_APP_strapiUrl}/api/upload`,
  //         formData,
  //         {
  //           headers: {
  //             Authorization: headers.Authorization,
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );

  //       uploadedId = uploadRes.data[0].id;
  //     }

  //     const oldPaymentReceipts =
  //       memberData[0]?.attributes?.Payment_Reciept?.data?.map(
  //         (item: { id: number }) => item.id
  //       ) || [];
  //     const updatedPaymentReceipts = [...oldPaymentReceipts, uploadedId].filter(
  //       Boolean
  //     );

  //     const data = {
  //       data: {
  //         Type_Of_Membership: membershipType,
  //         Membership_Valid: membershipExpiry,
  //         Status: "Pending",
  //         Payment_Reciept: updatedPaymentReceipts,
  //       },
  //     };
  //     axios
  //       .put(
  //         `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberData[0]?.id}`,
  //         data,
  //         {
  //           headers: headers,
  //         }
  //       )
  //       .then(async () => {
  //         navigate("/");
  //         dynamicSuccess("Successfull! payment pending");
  //         window.location.reload();
  //       })
  //       .catch(() => failed());
  //   } catch (e) {
  //     setLoading(false);
  //   }
  // };

  const sendCreatedEmail = (
    name: string,
    toEmail: string,
    attachments: Record<string, File>,
  ) => {
    axios.post(`${process.env.REACT_APP_NOTIFICATION_URL}/notification`, {
      templateId: "4f425c0e-157b-42bd-86e5-64179cbfa74b",
      senderId: 5171,
      payload: {
        FullName: name,
        CurrentYear: getFormattedDate(0, 0).slice(0, 4),
      },
      users: [
        {
          sisID: 1232,
          email: toEmail,
        },
      ],
    });

    const formData = new FormData();
    formData.append("templateId", "d23dcd9e-4af1-4132-89c1-2e3d90141328");
    formData.append("senderId", JSON.stringify(5171));
    formData.append(
      "payload",
      JSON.stringify({
        FullName: name,
        CurrentYear: getFormattedDate(0, 0).slice(0, 4),
      }),
    );
    formData.append(
      "users",
      JSON.stringify([
        { sisID: 1233, email: "frcsitsecretary@gmail.com" },
        { sisID: 1234, email: "secretary@frcsit.com" },
      ]),
    );

    const fileNames = [
      "Photograph",
      "Bachelor_Degree",
      "Master_Degree",
      "MCI",
      "Photo_ID",
      "Curriculum_Vitae",
    ];

    Object.values(attachments).forEach((file, index) => {
      formData.append("attachments", file, fileNames[index]);
    });

    axios.post(
      `${process.env.REACT_APP_NOTIFICATION_URL}/notification/trigger`,
      formData,
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    setShowWarning(true);
    let createUsersisId;
    let createUserId;
    try {
      const locationDetail = {
        area_name: "Chhauni",
        street_name: "Kakancho Binayak Marg",
        nearest_landmark: "",
        municipalities_id: 332,
        district_id: 28,
        province_id: 3,
      };

      const locationRes = await axios.post(
        `${process.env.REACT_APP_locationUrl}/location`,
        locationDetail,
        {
          headers: sisheaders,
        },
      );

      const userDetail = {
        name: firstname,
        phone_no: mobilenumber,
        address: JSON.stringify({
          area_name: { id: locationRes?.data?.area_id },
          street_name: { id: locationRes?.data?.street_id },
          nearest_landmark: "",
          municipalities_id: 332,
          district_id: 28,
          province_id: 3,
        }),
        email: email,
        gender: sex === "Male" ? 1 : 2,
        dob: "2000-01-01T00:00:00+05:45",
        password: password,
        password_confirmation: reenterPassword,
        status: 0,
        roles: ["member"],
        profile_pic: null,
      };

      const identityRes = await axios.post(
        `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users`,
        userDetail,
        {
          headers: sisheaders,
        },
      );

      if (identityRes?.data?.status !== "success") {
        dynamicFailed(identityRes?.data?.message);
        setLoading(false);
        setShowWarning(false);
        return;
      }

      createUsersisId = identityRes?.data?.user.id;

      const frcsitUserData = {
        data: {
          sis_id: String(identityRes?.data?.user?.id),
          Email: email,
          First_Name: firstname,
          Middle_Name: middlename,
          Last_Name: lastname,
          Age: age,
          Sex: sex,
          ENT: ent,
          Designation: designation,
          Qualifications: qualifications,
          Professional_Affiliations: professionalAffiliations,
          Mobile_Number: mobilenumber,
          WhatsAPP_Number: whatsappnumber,
          Permanent_Address: permanentAddress,
          City: city,
          State_Province: stateProvince,
          Postal_Zip_Code: postalZipCode,
          Country: country,
          Work_Address: workAddress,
          Work_City: workCity,
          Work_State_Province: workStateProvince,
          Work_Postal_Zip_Code: workPostalZipCode,
          Work_Country: workCountry,
          Full_Member_Name1: proposer1Name,
          Membership_Number1: proposer1MembershipNumber,
          Full_Member_Name2: proposer2Name,
          Membership_Number2: proposer2MembershipNumber,
          Type_Of_Membership: membershipType,
          Membership_Valid: membershipExpiry,
          Status: "Pending",
          Payment_Received: false,
        },
      };

      const frcsitRes = await axios.post(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-users`,
        frcsitUserData,
        { headers },
      );

      createUserId = frcsitRes.data.data.id;

      const uploadedFileIds: { [key: number]: number } = {};

      for (const id in selectedFiles) {
        const file = selectedFiles[Number(id)];
        const formData = new FormData();
        formData.append("files", file);

        const uploadRes = await axios.post(
          `${process.env.REACT_APP_strapiUrl}/api/upload`,
          formData,
          {
            headers: {
              Authorization: headers.Authorization,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        const uploadedId = uploadRes.data[0]?.id;
        uploadedFileIds[Number(id)] = uploadedId;
      }

      const updatePayload = {
        data: {
          Photograph: uploadedFileIds[1],
          Bachelor_Degree: uploadedFileIds[2],
          Master_Degree: uploadedFileIds[3],
          MCI: uploadedFileIds[4],
          Photo_ID: uploadedFileIds[5],
          Curriculum_Vitae: uploadedFileIds[6],
          be_frcsit_user: frcsitRes.data.data.id,
        },
      };

      const uploadLinkRes = await axios.post(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-uploads`,
        updatePayload,
        { headers },
      );

      if (uploadLinkRes?.status !== 200) {
        dynamicFailed("Failed to upload files!");
        setLoading(false);
        setShowWarning(false);
        return;
      }
      const message = {
        data: {
          Message:
            "Your account is under review. Please wait until it’s approved to make payment.",
          Type: "status",
          bf_frcsit_user: frcsitRes.data.data.id,
        },
      };
      const messageRes = await axios.post(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
        message,
        { headers },
      );
      if (messageRes?.status === 200) {
        setShowWarning(false);
        navigate("/");
        dynamicSuccess("User created successfully!");
        sendCreatedEmail(
          [firstname, middlename, lastname].filter(Boolean).join(" "),
          email,
          selectedFiles,
        );
      }
    } catch (e: any) {
      if (createUsersisId) {
        deleteFromUser(createUsersisId, sisheaders, createUserId);
      }
      await sendErrorLog(
        "Form Submission Error",
        `${firstname} ${lastname}`,
        email,
        mobilenumber,
        e?.config?.url,
        e.message,
        selectedFiles,
      );
      dynamicFailed(`${e.message}`);
      setLoading(false);
      setShowWarning(false);
    }
  };
  // const userDetail = {
  //   name: firstname,
  //   phone_no: mobilenumber,
  //   address: JSON.stringify({
  //     area_name: { id: res?.data?.area_id },
  //     street_name: { id: res?.data?.street_id },
  //     nearest_landmark: "",
  //     municipalities_id: 332,
  //     district_id: 28,
  //     province_id: 3,
  //   }),
  //   email: email,
  //   gender: sex === "Male" ? 1 : 2,
  //   dob: "2000-01-01T00:00:00+05:45",
  //   //   password: password,
  //   //   password_confirmation: reenterPassword,
  //   status: 0,
  //   roles: ["member"],
  //   profile_pic: null,
  // };
  // const userUpRes = await axios.put(
  //   `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users/${userRes?.data?.user?.id}`,
  //   userDetail,
  //   {
  //     headers: sisheaders,
  //   }
  // );
  // if (userUpRes?.data?.status === "success") {
  // }

  const markStepCompleted = (stepNumber: number) => {
    setCompletedSteps((prev) => {
      if (!prev.includes(stepNumber)) {
        return [...prev, stepNumber];
      }
      return prev;
    });
  };

  const handleStepClick = async (targetStep: number) => {
    if (targetStep < step) {
      setStep(targetStep);
      memberDetailsRef.current?.scrollIntoView({ behavior: "smooth" });
      return;
    }

    let canProceed = true;
    for (let i = step; i < targetStep; i++) {
      const isValid = await validateStep(i);

      if (!isValid) {
        canProceed = false;
        break;
      } else {
        if (step + 1 === targetStep || step === 2) {
          markStepCompleted(i);
        }
      }
    }

    if (canProceed) {
      setStep(targetStep);
      memberDetailsRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <section className="become-volunteer">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-5">
              <div className="become-volunteer__Left">
                <div className="become-volunteer__images">
                  <div className="row">
                    {!loading && (
                      <>
                        <div className="col-xl-6 col-lg-6 col-md-6">
                          <Fade
                            cascade
                            damping={0.2}
                            direction="left"
                            triggerOnce={true}
                          >
                            <div className="become-volunteer__img-single">
                              <img
                                src={
                                  props?.becomeMemberData[0]?.first_image[0]
                                    ?.media?.url &&
                                  `${process.env.REACT_APP_cmsUrl}${props?.becomeMemberData[0]?.first_image[0]?.media?.url}`
                                }
                                alt="member-img-one"
                                style={{ objectFit: "cover" }}
                              />
                            </div>
                          </Fade>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6">
                          <Fade
                            cascade
                            damping={0.2}
                            direction="left"
                            delay={200}
                            triggerOnce={true}
                          >
                            <div className="become-volunteer__img-single">
                              <img
                                src={
                                  props?.becomeMemberData[0]?.second_image[0]
                                    ?.media?.url &&
                                  `${process.env.REACT_APP_cmsUrl}${props?.becomeMemberData[0]?.second_image[0]?.media?.url}`
                                }
                                alt="member-img-two"
                                style={{ objectFit: "cover" }}
                              />
                            </div>
                          </Fade>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="become-volunteer__content">
                  <h3
                    className="section-title__title"
                    style={{ marginBottom: "15px" }}
                  >
                    {props?.becomeMemberData[0]?.title}
                  </h3>
                  <p
                    className="become-volunteer__text"
                    style={{ textAlign: "justify" }}
                    dangerouslySetInnerHTML={{
                      __html: markedDescription,
                    }}
                  ></p>
                  <div
                    className="become-volunteer__btn-box"
                    style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                  >
                    <button
                      className="thm-btn become-volunteer__btn"
                      onClick={() => setShowRequirements(true)}
                      style={{ width: "200px" }}
                    >
                      View Requirements
                    </button>
                    {/* <a
                      href={`${process.env.REACT_APP_strapiUrl}${props?.becomeMemberData[0]?.attributes?.File?.data?.attributes?.url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="thm-btn become-volunteer__btn"
                      style={{ width: "200px" }}
                    >
                      Download the Form
                    </a> */}
                  </div>
                  <div className="become-volunteer__contact">
                    <p>
                      <a
                        href={`tel:${companyDetailsData[0]?.phone_number}`}
                        className="become-volunteer__phone"
                      >
                        {companyDetailsData[0]?.phone_number}
                      </a>
                      <a
                        href={`mailto:${companyDetailsData[0]?.email}`}
                        className="become-volunteer__email"
                      >
                        {companyDetailsData[0]?.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xl-7 col-lg-7"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="become-volunteer__right">
                {/* <div className="custom-qr-section">
                <p
                  style={{
                    marginBottom: "0px",
                    textAlign: "center",
                    lineHeight: "25px",
                  }}
                >
                  For membership payment kindly make payment to QR code provided
                  below.
                </p>
                <img
                  src={qr}
                  alt="qr-image"
                  style={{
                    objectFit: "cover",
                    width: mobile ? "100%" : "50%",
                    height: mobile ? "100%" : "50%",
                  }}
                />
              </div> */}
                <div ref={memberDetailsRef}></div>
                <Stepper
                  activeStep={step}
                  alternativeLabel
                  sx={{
                    marginBottom: "20px",
                    "& .MuiStepIcon-root.Mui-completed": {
                      color: "#43b3f8",
                    },
                    "& .MuiStepIcon-root.Mui-active": {
                      color: "#43b3f8",
                    },
                  }}
                >
                  {steps.map((label, index) => (
                    <Step
                      key={index}
                      completed={completedSteps.includes(index)}
                    >
                      <StepLabel
                        onClick={() => handleStepClick(index)}
                        style={{ cursor: "pointer" }}
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
                <form className="become-volunteer__form" ref={formRef}>
                  <div className="row">
                    {step === 0 && (
                      <>
                        <h3
                          className="section-title__title"
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          Account Details
                        </h3>
                        <div className="col-xl-4">
                          <div className="become-volunteer__input">
                            <input
                              type="text"
                              placeholder="First Name*"
                              name="firstname"
                              value={firstname}
                              onChange={(e) => setFirstname(e.target.value)}
                              className={errors.firstname && "error-border"}
                            />
                            {errors.firstname && (
                              <p className="error-message">
                                {errors.firstname}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="become-volunteer__input">
                            <input
                              type="text"
                              placeholder="Middle Name"
                              name="middlename"
                              value={middlename}
                              onChange={(e) => setMiddlename(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="become-volunteer__input">
                            <input
                              type="text"
                              placeholder="Last Name*"
                              name="lastname"
                              value={lastname}
                              onChange={(e) => setLastname(e.target.value)}
                              className={errors.lastname && "error-border"}
                            />
                            {errors.lastname && (
                              <p className="error-message">{errors.lastname}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="become-volunteer__input">
                            <input
                              type="number"
                              placeholder="Age*"
                              name="age"
                              value={age || ""}
                              onChange={(e) => setAge(Number(e.target.value))}
                              className={errors.age && "error-border"}
                            />
                            {errors.age && (
                              <p className="error-message">{errors.age}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-4">
                          <div className="become-volunteer__input">
                            <select
                              name="Gender"
                              className={`become-volunteer__select ${
                                errors.sex && "error-border"
                              }`}
                              defaultValue=""
                              value={sex}
                              onChange={(e) => setSex(e.target.value)}
                            >
                              <option value="" disabled>
                                Gender*
                              </option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                            {errors.sex && (
                              <p className="error-message">{errors.sex}</p>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-xl-4">
                          <div
                            className="become-volunteer__input"
                          >
                            <label style={{ fontSize: "14px" }}>ENT:</label>
                            <div style={{ display: "flex", gap: "15px" }}>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  fontSize: "14px",
                                }}
                              >
                                <input
                                  type="radio"
                                  name="ent"
                                  value="Yes"
                                  checked={ent === "Yes"}
                                  onChange={(e) => setEnt(e.target.value)}
                                />
                                Yes
                              </label>

                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  fontSize: "14px",
                                }}
                              >
                                <input
                                  type="radio"
                                  name="ent"
                                  value="No"
                                  checked={ent === "No"}
                                  onChange={(e) => setEnt(e.target.value)}
                                />
                                No
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-xl-4">
                          <DropDownInput
                            label="ENT*"
                            value={ent}
                            onChange={setEnt}
                            options={["ENT*", "Yes", "No"]}
                            error={errors.ent}
                          />
                          {errors.ent && (
                            <p
                              className="error-message"
                              style={{ marginTop: "-31px" }}
                            >
                              {errors.ent}
                            </p>
                          )}
                        </div>

                        <div className="col-xl-12">
                          <div className="become-volunteer__input">
                            <input
                              type="text"
                              placeholder="Designation*"
                              name="designation"
                              value={designation}
                              onChange={(e) => setDesignation(e.target.value)}
                              className={errors.designation && "error-border"}
                            />
                            {errors.designation && (
                              <p className="error-message">
                                {errors.designation}
                              </p>
                            )}
                          </div>
                        </div>

                        <div
                          className="col-xl-6"
                          style={{
                            marginBottom:
                              errors.professionalAffiliations ||
                              errors.qualifications
                                ? "20px"
                                : "unset",
                          }}
                        >
                          <div className="become-volunteer__input become-volunteer__message-box">
                            <textarea
                              name="qualifications"
                              placeholder="Qualifications*"
                              value={qualifications}
                              onChange={(e) =>
                                setQualifications(e.target.value)
                              }
                              className={
                                errors.qualifications && "error-border"
                              }
                            ></textarea>
                            {errors.qualifications && (
                              <p
                                className="error-message"
                                style={{ marginTop: "-7px" }}
                              >
                                {errors.qualifications}
                              </p>
                            )}
                          </div>
                        </div>
                        <div
                          className="col-xl-6"
                          style={{
                            marginBottom:
                              errors.professionalAffiliations ||
                              errors.qualifications
                                ? "20px"
                                : "unset",
                          }}
                        >
                          <div className="become-volunteer__input become-volunteer__message-box">
                            <textarea
                              name="professionalaffiliations"
                              placeholder="Professional Affiliations*"
                              value={professionalAffiliations}
                              onChange={(e) =>
                                setProfessionalAffiliations(e.target.value)
                              }
                              className={
                                errors.professionalAffiliations &&
                                "error-border"
                              }
                            ></textarea>
                            {errors.professionalAffiliations && (
                              <p
                                className="error-message"
                                style={{ marginTop: "-7px" }}
                              >
                                {errors.professionalAffiliations}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="become-volunteer__input">
                            <input
                              type="text"
                              placeholder="Email ID*"
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              className={errors.email && "error-border"}
                            />
                            {errors.email && (
                              <p className="error-message">{errors.email}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type={showPassword ? "text" : "password"}
                              placeholder="Password*"
                              name="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              className={
                                passwordErrors.length > 0 ? "error-border" : ""
                              }
                            />
                            <i
                              className={`main-header-two__cart ${
                                showPassword ? "icon-eye-blocked" : "icon-eye"
                              } mini-cart__toggler custom-password-icon`}
                              onClick={togglePasswordVisibility}
                            ></i>
                          </div>
                          <ul
                            className="info-message"
                            style={{
                              marginTop: "-31px",
                              marginBottom: mobile || tab ? "25px" : "unset",
                            }}
                          >
                            {passwordErrors.includes("required") && (
                              <li
                                className="error-message"
                                style={{ marginLeft: "unset" }}
                              >
                                Password is required
                              </li>
                            )}
                            <li
                              className={
                                passwordErrors.includes("8char")
                                  ? "error-message"
                                  : ""
                              }
                              style={{ marginLeft: "unset" }}
                            >
                              At least 8 characters required
                            </li>
                            <li
                              className={
                                passwordErrors.includes("uppercase")
                                  ? "error-message"
                                  : ""
                              }
                              style={{ marginLeft: "unset" }}
                            >
                              At least one uppercase letter
                            </li>
                            <li
                              className={
                                passwordErrors.includes("number")
                                  ? "error-message"
                                  : ""
                              }
                              style={{ marginLeft: "unset" }}
                            >
                              At least one number
                            </li>
                            <li
                              className={
                                passwordErrors.includes("symbol")
                                  ? "error-message"
                                  : ""
                              }
                              style={{ marginLeft: "unset" }}
                            >
                              At least one symbol
                            </li>
                          </ul>
                        </div>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type={showRePassword ? "text" : "password"}
                              placeholder="Re-enter Password*"
                              name="reenterpassword"
                              value={reenterPassword}
                              onChange={(e) =>
                                setReenterPassword(e.target.value)
                              }
                              className={errors.password && "error-border"}
                            />

                            <i
                              className={`main-header-two__cart ${
                                showRePassword ? "icon-eye-blocked" : "icon-eye"
                              } mini-cart__toggler custom-password-icon`}
                              onClick={toggleRePasswordVisibility}
                            ></i>
                          </div>
                          {errors.reenterPassword && (
                            <p
                              className="error-message"
                              style={{
                                marginTop: "-30px",
                                marginBottom: "2.4em",
                              }}
                            >
                              {errors.reenterPassword}
                            </p>
                          )}
                        </div>
                      </>
                    )}
                    {step === 1 && (
                      <>
                        <h3
                          className="section-title__title"
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          Contact Details
                        </h3>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="number"
                              placeholder="Mobile Number*"
                              name="mobilenumber"
                              value={mobilenumber}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              className={errors.mobilenumber && "error-border"}
                            />
                            {errors.mobilenumber && (
                              <p className="error-message">
                                {errors.mobilenumber}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="number"
                              placeholder="WhatsApp Number"
                              name="whatsappnumber"
                              value={whatsappnumber}
                              onChange={(e) =>
                                setWhatsappNumber(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="faq-page__single">
                            <div
                              className="accrodion-grp faq-one-accrodion"
                              data-grp-name="faq-one-accrodion-1"
                            >
                              <div
                                className={`accrodion ${
                                  openAccordion === "permanent" && "active"
                                }`}
                              >
                                <div
                                  className="accrodion-title"
                                  onClick={() => toggleAccordion("permanent")}
                                >
                                  <h4>Permanent Address</h4>
                                </div>
                                <div
                                  className="accrodion-content"
                                  style={{
                                    marginTop:
                                      openAccordion !== "permanent"
                                        ? "-11px"
                                        : "-6px",
                                  }}
                                >
                                  <div className="inner">
                                    <div className="row">
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <select
                                            name="country"
                                            className={`become-volunteer__select ${
                                              errors.country && "error-border"
                                            }`}
                                            defaultValue=""
                                            value={country}
                                            onChange={(e) => {
                                              setCountry(e.target.value);
                                              setStateProvince("");
                                              setCity("");
                                            }}
                                          >
                                            <option value="" disabled>
                                              Country*
                                            </option>
                                            {Object.entries(countryDetails)
                                              .sort(([, a], [, b]) =>
                                                a.name.localeCompare(b.name),
                                              )
                                              .map(([key, value]) => (
                                                <option
                                                  key={key}
                                                  value={value.name}
                                                >
                                                  {value.name}
                                                </option>
                                              ))}
                                          </select>
                                          {errors.country && (
                                            <p className="error-message">
                                              {errors.country}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <select
                                            name="stateprovince"
                                            className={`become-volunteer__select ${
                                              errors.stateProvince &&
                                              "error-border"
                                            }`}
                                            defaultValue=""
                                            value={stateProvince}
                                            onChange={(e) => {
                                              setStateProvince(e.target.value);
                                              setCity("");
                                            }}
                                          >
                                            <option value="" disabled>
                                              State/Province*
                                            </option>
                                            {!country && (
                                              <option disabled>
                                                Select a country first
                                              </option>
                                            )}

                                            {country &&
                                              Object.entries(countryDetails)
                                                .filter(
                                                  ([_, value]) =>
                                                    value.name === country,
                                                )
                                                .flatMap(([key, value]) => {
                                                  const stateNames =
                                                    Object.keys(
                                                      value.states || {},
                                                    ).sort();
                                                  return stateNames.map(
                                                    (state, idx) => (
                                                      <option
                                                        key={`${key}-${idx}`}
                                                        value={state}
                                                      >
                                                        {state}
                                                      </option>
                                                    ),
                                                  );
                                                })}
                                          </select>
                                          {errors.stateProvince && (
                                            <p className="error-message">
                                              {errors.stateProvince}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <select
                                            name="city"
                                            className={`become-volunteer__select ${
                                              errors.city ? "error-border" : ""
                                            }`}
                                            defaultValue=""
                                            value={city}
                                            onChange={(e) =>
                                              setCity(e.target.value)
                                            }
                                          >
                                            <option value="" disabled>
                                              City*
                                            </option>
                                            {!stateProvince && (
                                              <option disabled>
                                                Select a state/province first
                                              </option>
                                            )}

                                            {stateProvince &&
                                              Object.entries(
                                                countryDetails,
                                              ).flatMap(
                                                ([
                                                  countryKey,
                                                  countryValue,
                                                ]) => {
                                                  const states =
                                                    countryValue.states || {};

                                                  return Object.entries(states)
                                                    .filter(
                                                      ([stateKey]) =>
                                                        stateKey ===
                                                        stateProvince,
                                                    )
                                                    .flatMap(
                                                      ([
                                                        stateKey,
                                                        cityArray,
                                                      ]) => {
                                                        if (
                                                          !Array.isArray(
                                                            cityArray,
                                                          ) ||
                                                          cityArray.length === 0
                                                        )
                                                          return [];

                                                        return [...cityArray]
                                                          .sort((a, b) =>
                                                            a.name.localeCompare(
                                                              b.name,
                                                            ),
                                                          )
                                                          .map(
                                                            (
                                                              cityObj: any,
                                                              idx: number,
                                                            ) => (
                                                              <option
                                                                key={`${stateKey}-${idx}`}
                                                                value={
                                                                  cityObj.name
                                                                }
                                                              >
                                                                {cityObj.name}
                                                              </option>
                                                            ),
                                                          );
                                                      },
                                                    );
                                                },
                                              )}
                                          </select>
                                          {errors.city && (
                                            <p className="error-message">
                                              {errors.city}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <input
                                            type="number"
                                            placeholder="Postal/Zip Code"
                                            name="postalzipcode"
                                            value={postalZipCode || ""}
                                            onChange={(e) =>
                                              setPostalZipCode(
                                                Number(e.target.value),
                                              )
                                            }
                                            className={
                                              errors.postalZipCode &&
                                              "error-border"
                                            }
                                          />
                                          {errors.postalZipCode && (
                                            <p className="error-message">
                                              {errors.postalZipCode}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-xl-12">
                                        <div className="become-volunteer__input">
                                          <input
                                            type="text"
                                            placeholder="Permanent Address*"
                                            name="permanentaddress"
                                            value={permanentAddress}
                                            onChange={(e) =>
                                              setPermanentAddress(
                                                e.target.value,
                                              )
                                            }
                                            className={
                                              errors.permanentAddress &&
                                              "error-border"
                                            }
                                          />
                                          {errors.permanentAddress && (
                                            <p className="error-message">
                                              {errors.permanentAddress}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="faq-page__single">
                            <div
                              className="accrodion-grp faq-one-accrodion"
                              data-grp-name="faq-one-accrodion-1"
                            >
                              <div
                                className={`accrodion ${
                                  openAccordion === "work" && "active"
                                }`}
                              >
                                <div
                                  className="accrodion-title"
                                  onClick={() => toggleAccordion("work")}
                                >
                                  <h4>Work Address</h4>
                                </div>
                                <div
                                  className="accrodion-content"
                                  style={{
                                    marginTop:
                                      openAccordion !== "work"
                                        ? "-11px"
                                        : "-6px",
                                  }}
                                >
                                  <div className="inner">
                                    <div className="row">
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <select
                                            name="country"
                                            className="become-volunteer__select"
                                            defaultValue=""
                                            value={workCountry}
                                            onChange={(e) => {
                                              setWorkCountry(e.target.value);
                                              setWorkStateProvince("");
                                              setWorkCity("");
                                            }}
                                          >
                                            <option value="" disabled>
                                              Country
                                            </option>
                                            {Object.entries(countryDetails)
                                              .sort(([, a], [, b]) =>
                                                a.name.localeCompare(b.name),
                                              )
                                              .map(([key, value]) => (
                                                <option
                                                  key={key}
                                                  value={value.name}
                                                >
                                                  {value.name}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <select
                                            name="stateprovince"
                                            className="become-volunteer__select"
                                            defaultValue=""
                                            value={workStateProvince}
                                            onChange={(e) => {
                                              setWorkStateProvince(
                                                e.target.value,
                                              );
                                              setWorkCity("");
                                            }}
                                          >
                                            <option value="" disabled>
                                              State/Province
                                            </option>
                                            {!workCountry && (
                                              <option disabled>
                                                Select a country first
                                              </option>
                                            )}

                                            {workCountry &&
                                              Object.entries(countryDetails)
                                                .filter(
                                                  ([_, value]) =>
                                                    value.name === workCountry,
                                                )
                                                .flatMap(([key, value]) => {
                                                  const stateNames =
                                                    Object.keys(
                                                      value.states || {},
                                                    ).sort();
                                                  return stateNames.map(
                                                    (state, idx) => (
                                                      <option
                                                        key={`${key}-${idx}`}
                                                        value={state}
                                                      >
                                                        {state}
                                                      </option>
                                                    ),
                                                  );
                                                })}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <select
                                            name="city"
                                            className="become-volunteer__select"
                                            defaultValue=""
                                            value={workCity}
                                            onChange={(e) =>
                                              setWorkCity(e.target.value)
                                            }
                                          >
                                            <option value="" disabled>
                                              City
                                            </option>
                                            {!workStateProvince && (
                                              <option disabled>
                                                Select a state/province first
                                              </option>
                                            )}

                                            {workStateProvince &&
                                              Object.entries(
                                                countryDetails,
                                              ).flatMap(
                                                ([
                                                  countryKey,
                                                  countryValue,
                                                ]) => {
                                                  const states =
                                                    countryValue.states || {};

                                                  return Object.entries(states)
                                                    .filter(
                                                      ([stateKey]) =>
                                                        stateKey ===
                                                        workStateProvince,
                                                    )
                                                    .flatMap(
                                                      ([
                                                        stateKey,
                                                        cityArray,
                                                      ]) => {
                                                        if (
                                                          !Array.isArray(
                                                            cityArray,
                                                          ) ||
                                                          cityArray.length === 0
                                                        )
                                                          return [];

                                                        return [...cityArray]
                                                          .sort((a, b) =>
                                                            a.name.localeCompare(
                                                              b.name,
                                                            ),
                                                          )
                                                          .map(
                                                            (
                                                              cityObj: any,
                                                              idx: number,
                                                            ) => (
                                                              <option
                                                                key={`${stateKey}-${idx}`}
                                                                value={
                                                                  cityObj.name
                                                                }
                                                              >
                                                                {cityObj.name}
                                                              </option>
                                                            ),
                                                          );
                                                      },
                                                    );
                                                },
                                              )}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="become-volunteer__input">
                                          <input
                                            type="number"
                                            placeholder="Postal/Zip Code"
                                            name="postalzipcode"
                                            value={workPostalZipCode || ""}
                                            onChange={(e) =>
                                              setWorkPostalZipCode(
                                                Number(e.target.value),
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col-xl-12">
                                        <div className="become-volunteer__input">
                                          <input
                                            type="text"
                                            placeholder="Work Address"
                                            name="workaddress"
                                            value={workAddress}
                                            onChange={(e) =>
                                              setWorkAddress(e.target.value)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {step === 2 && (
                      <>
                        <h3
                          className="section-title__title"
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          Required Documents
                        </h3>
                        {uploadFields.map((field) => {
                          const selectedFile = selectedFiles[field.id];
                          const preview = previews[field.id];
                          const isPdf =
                            selectedFile &&
                            selectedFile.type === "application/pdf";
                          const error = errors[`file_${field.id}`];

                          return (
                            <div className="col-xl-6" key={field.id}>
                              <div className="become-volunteer__input custom-file-input">
                                {preview ? (
                                  <div
                                    className="user-card__image"
                                    style={{ cursor: "default" }}
                                  >
                                    {isPdf ? (
                                      <iframe
                                        src={preview}
                                        title="PDF Preview"
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          border: "1px solid #ccc",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={preview}
                                        alt="Preview"
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    )}
                                    <div
                                      className="edit-profil-pic-icon"
                                      style={{ top: "0px", left: "65px" }}
                                      onClick={() =>
                                        document
                                          .getElementById(
                                            `file-upload-${field.id}`,
                                          )
                                          ?.click()
                                      }
                                    >
                                      <span className="icon-pencil"></span>
                                    </div>
                                  </div>
                                ) : (
                                  <label
                                    htmlFor={`file-upload-${field.id}`}
                                    className={error && "error-border"}
                                  >
                                    {`Click To Upload ${field.label}`}
                                  </label>
                                )}

                                <input
                                  type="file"
                                  id={`file-upload-${field.id}`}
                                  name={`file-upload-${field.id}`}
                                  accept={field.types
                                    .split(",")
                                    .map((type) => `.${type.trim()}`)
                                    .join(",")}
                                  onChange={(e) =>
                                    handleFileChange(e, field.id)
                                  }
                                  style={{ display: "none" }}
                                />
                                <p
                                  className="upload-subtext"
                                  style={{ marginBottom: "unset" }}
                                >
                                  Allowed file types: {field.types}
                                </p>

                                {error && (
                                  <p
                                    className="error-message"
                                    style={{ marginLeft: "unset" }}
                                  >
                                    {error.replace(/\*/g, "")}
                                  </p>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </>
                    )}
                    {step === 3 && (
                      <>
                        <h3
                          className="section-title__title"
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          Proposed By
                        </h3>
                        <h6 className="become-volunteer__sub-title">
                          Full Member Number 1
                        </h6>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="text"
                              placeholder="Name"
                              name="name"
                              value={proposer1Name}
                              onChange={(e) => setProposer1Name(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="number"
                              placeholder="Membership Number"
                              name="membershipnumber"
                              value={proposer1MembershipNumber || ""}
                              onChange={(e) =>
                                setProposer1MembershipNumber(
                                  Number(e.target.value),
                                )
                              }
                            />
                          </div>
                        </div>
                        <h6 className="become-volunteer__sub-title">
                          Full Member Number 2
                        </h6>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="text"
                              placeholder="Name"
                              name="name"
                              value={proposer2Name}
                              onChange={(e) => setProposer2Name(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="number"
                              placeholder="Membership Number"
                              name="membershipnumber"
                              value={proposer2MembershipNumber || ""}
                              onChange={(e) =>
                                setProposer2MembershipNumber(
                                  Number(e.target.value),
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-12">
                          <div className="become-volunteer__input">
                            <p
                              style={{
                                fontSize: "12px",
                                lineHeight: "15px",
                                color: "#43b3f8",
                              }}
                            >
                              Recommendation from a full member is desirable for
                              approval, but not mandatory. The member number is
                              not required.
                            </p>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <input
                                type="checkbox"
                                id="declaration"
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                                style={{
                                  accentColor: "#43b3f8",
                                  width: "12px",
                                  height: "12px",
                                  cursor: "pointer",
                                }}
                              />
                              <label
                                htmlFor="declaration"
                                style={{
                                  fontSize: "12px",
                                  lineHeight: "15px",
                                  cursor: "pointer",
                                }}
                              >
                                I declare that information given is true to the
                                best of my knowledge
                              </label>
                            </div>
                            {errors.declaration && (
                              <p
                                className="error-message"
                                style={{ marginLeft: "20px" }}
                              >
                                {errors.declaration}
                              </p>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {step === 4 && (
                      <>
                        <h3
                          className="section-title__title"
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          Type Of Membership
                        </h3>

                        {filteredMemberships.map((membership) => (
                          <div
                            key={membership.id}
                            className="col-xl-12"
                            style={{
                              display: "flex",
                              marginBottom: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleSelectMembership(membership.id);
                              setMembershipType(
                                `${membership.title} ${
                                  membership.expires_in_yrs === 1
                                    ? "(ANNUALLY)"
                                    : membership.expires_in_yrs === 0
                                      ? ""
                                      : `(${toWords(
                                          membership.expires_in_yrs,
                                        ).toUpperCase()} YEARS)`
                                }`,
                              );
                              setMembershipExpiry(membership.expires_in_yrs);
                            }}
                          >
                            <div className="membership-radio-container">
                              <input
                                type="radio"
                                name="membership"
                                checked={selectedMembership === membership.id}
                              />
                            </div>
                            <div
                              className="membership-card"
                              style={{
                                backgroundColor:
                                  selectedMembership === membership.id
                                    ? "#f2f0ec"
                                    : "",
                              }}
                            >
                              <div className="membership-content">
                                <h3>
                                  {membership.title}{" "}
                                  {membership.expires_in_yrs === 1
                                    ? "(ANNUALLY)"
                                    : membership.expires_in_yrs === 0
                                      ? ""
                                      : `(${toWords(
                                          membership.expires_in_yrs,
                                        ).toUpperCase()} YEARS)`}
                                </h3>
                                <p>{membership.description}</p>
                                {membership.price_details && (
                                  <span className="membership-price">
                                    {membership.price_details}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                        {/* {selectedMembership === 5 && (
                        <div className="col-xl-6">
                          <div className="become-volunteer__input">
                            <input
                              type="number"
                              placeholder="Affiliate Reference Number*"
                              name="affiliatereferencenumber"
                            />
                          </div>
                        </div>
                      )} */}

                        {/* <div className="col-xl-12" style={{ marginTop: "30px" }}>
                        <div className="become-volunteer__input custom-file-input">
                          {preview ? (
                            <>
                              <div
                                className="user-card__image"
                                style={{ cursor: "default" }}
                              >
                                {isPdf ? (
                                  <iframe
                                    src={preview}
                                    title="PDF Preview"
                                    style={{
                                      width: "80px",
                                      height: "80px",
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                ) : (
                                  <img src={preview} alt="Preview" />
                                )}

                                <div
                                  className="edit-profil-pic-icon"
                                  style={{ top: "0px", left: "65px" }}
                                  onClick={handleEditClick}
                                >
                                  <span className="icon-pencil"></span>
                                </div>
                              </div>
                              <input
                                type="file"
                                accept=".png,.jpg,.jpeg,.pdf"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />
                            </>
                          ) : (
                            <>
                              <label
                                htmlFor="profile-image-upload"
                                style={{ cursor: "pointer" }}
                              >
                                Upload Payment Receipt* (.png, .jpg, .jpeg,
                                .pdf)
                              </label>
                              <input
                                type="file"
                                id="profile-image-upload"
                                accept=".png,.jpg,.jpeg,.pdf"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                              />
                            </>
                          )}
                          {receiptError.selectedFile && (
                            <p className="error-message">
                              {receiptError.selectedFile}
                            </p>
                          )}
                        </div>
                      </div> */}
                      </>
                    )}
                  </div>
                </form>
                <div className="become-volunteer__btn-container">
                  {step > 0 && (
                    <button
                      onClick={handlePrev}
                      className="thm-btn become-volunteer__btn become-volunteer__prev-btn"
                      disabled={memberData}
                      style={{
                        cursor: memberData ? "not-allowed" : "pointer",
                        opacity: memberData ? 0.5 : 1,
                      }}
                    >
                      <i className="icon-arrow-left2"></i>
                      Back
                    </button>
                  )}
                  {step < 4 ? (
                    <button
                      onClick={handleNext}
                      className="thm-btn become-volunteer__btn become-volunteer__next-btn"
                    >
                      Next
                      <i className="icon-arrow-right2"></i>
                    </button>
                  ) : (
                    <div className="become-volunteer__btn-box">
                      <button
                        type="submit"
                        className="thm-btn become-volunteer__btn become-volunteer__submit"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FormRequirementsPopup
        open={showRequirements}
        onClose={() => setShowRequirements(false)}
        formRequirement={props.formRequirement}
      />
    </>
  );
};

export default BecomeMemberForm;
